import React, { Component } from 'react';
import InputFieldComponent from './InputFieldComponent';
import { connect } from 'react-redux';
import _ from 'lodash';
import { length } from 'redux-form-validators';
import format from 'string-template';
import { PASSWORD_MINLENGTH, PASSWORD_MAXLENGTH } from './constants';

class PasswordInputFieldComponent extends Component {
    validateMandatory = () => [
        length({
            min: PASSWORD_MINLENGTH,
            msg: format(this.props.i18nForm.PASSWORD_TOOSHORT, PASSWORD_MINLENGTH),
            allowBlank: !this.props.isRequired
        }),
        length({
            max: PASSWORD_MAXLENGTH,
            msg: format(this.props.i18nForm.PASSWORD_TOOLONG, PASSWORD_MAXLENGTH),
            allowBlank: !this.props.isRequired
        }),
        ..._.toArray(this.props.validate)
    ];

    render() {
        return (
            <InputFieldComponent
                {...this.props}
                type="password"
                validate={this.validateMandatory()}
            />
        );
    }
}

// See proptypes in ./InputFieldComponent.js for global Field props

const mapStateToProps = state => {
    return {
        i18nForm: state.i18n.feature.form
    };
};

export default connect(mapStateToProps)(PasswordInputFieldComponent);



// WEBPACK FOOTER //
// ./src/components/form/PasswordInputFieldComponent.js